'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Recipe(id_$_lo, id_$_hi, accountId_$_lo, accountId_$_hi, title, instructions, modifications, cuisine, rating, description, source, preptime, cooktime, servings, yields, yieldUnit, created, lastModified, ingredients, course, images, categories, keywords, rawHtml, importState, lastMade, nutrition) {
  this.c9 = 0;
  this.ca = 0;
  this.dy = 0;
  this.dz = 0;
  this.bL = null;
  this.cO = null;
  this.d7 = null;
  this.cG = null;
  this.d8 = null;
  this.dh = null;
  this.cj = null;
  this.cW = null;
  this.cT = null;
  this.ci = null;
  this.cy = null;
  this.cX = null;
  this.dg = null;
  this.ds = null;
  this.cn = null;
  this.cF = null;
  this.cU = null;
  this.cN = null;
  this.dr = null;
  this.dt = null;
  this.di = null;
  this.cV = null;
  this.dj = null;
  this.c9 = id_$_lo;
  this.ca = id_$_hi;
  this.dy = accountId_$_lo;
  this.dz = accountId_$_hi;
  this.bL = title;
  this.cO = instructions;
  this.d7 = modifications;
  this.cG = cuisine;
  this.d8 = rating;
  this.dh = description;
  this.cj = source;
  this.cW = preptime;
  this.cT = cooktime;
  this.ci = servings;
  this.cy = yields;
  this.cX = yieldUnit;
  this.dg = created;
  this.ds = lastModified;
  this.cn = ingredients;
  this.cF = course;
  this.cU = images;
  this.cN = categories;
  this.dr = keywords;
  this.dt = rawHtml;
  this.di = importState;
  this.cV = lastMade;
  this.dj = nutrition;
}
export { $c_Lmealorama_Recipe as $c_Lmealorama_Recipe };
$p = $c_Lmealorama_Recipe.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Recipe;
/** @constructor */
function $h_Lmealorama_Recipe() {
}
export { $h_Lmealorama_Recipe as $h_Lmealorama_Recipe };
$h_Lmealorama_Recipe.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 821750498, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Recipe)) {
    var x_$_lo = this.c9;
    var x_$_hi = this.ca;
    var $x_21 = x$0;
    var x$1_$_lo = $x_21.c9;
    var x$1_$_hi = $x_21.ca;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.dy;
      var x$2_$_hi = this.dz;
      var $x_22 = x$0;
      var x$3_$_lo = $x_22.dy;
      var x$3_$_hi = $x_22.dz;
      var $x_20 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_20 = false;
    }
    if ((($x_20 && (this.bL === x$0.bL)) && (this.cO === x$0.cO))) {
      var x$4 = this.d7;
      var x$2$1 = x$0.d7;
      var $x_19 = ((x$4 === null) ? (x$2$1 === null) : x$4.f(x$2$1));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$3$1 = this.cG;
      var x$4$1 = x$0.cG;
      var $x_18 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.f(x$4$1));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$5 = this.d8;
      var x$6 = x$0.d8;
      var $x_17 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$7 = this.dh;
      var x$8 = x$0.dh;
      var $x_16 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_16 = false;
    }
    if (($x_16 && (this.cj === x$0.cj))) {
      var x$9 = this.cW;
      var x$10 = x$0.cW;
      var $x_15 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$11 = this.cT;
      var x$12 = x$0.cT;
      var $x_14 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$13 = this.ci;
      var x$14 = x$0.ci;
      var $x_13 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$15 = this.cy;
      var x$16 = x$0.cy;
      var $x_12 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$17 = this.cX;
      var x$18 = x$0.cX;
      var $x_11 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$19 = this.dg;
      var x$20 = x$0.dg;
      var $x_10 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$21 = this.ds;
      var x$22 = x$0.ds;
      var $x_9 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$23 = this.cn;
      var x$24 = x$0.cn;
      var $x_8 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$25 = this.cF;
      var x$26 = x$0.cF;
      var $x_7 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$27 = this.cU;
      var x$28 = x$0.cU;
      var $x_6 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$29 = this.cN;
      var x$30 = x$0.cN;
      var $x_5 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$31 = this.dr;
      var x$32 = x$0.dr;
      var $x_4 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$33 = this.dt;
      var x$34 = x$0.dt;
      var $x_3 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$35 = this.di;
      var x$36 = x$0.di;
      var $x_2 = ((x$35 === null) ? (x$36 === null) : (x$35 === x$36));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$37 = this.cV;
      var x$38 = x$0.cV;
      var $x_1 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$39 = this.dj;
      var x$40 = x$0.dj;
      return ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 25;
});
$p.r = (function() {
  return "Recipe";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.c9, this.ca);
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.dy, this.dz);
      break;
    }
    case 2: {
      return this.bL;
      break;
    }
    case 3: {
      return this.cO;
      break;
    }
    case 4: {
      return this.d7;
      break;
    }
    case 5: {
      return this.cG;
      break;
    }
    case 6: {
      return this.d8;
      break;
    }
    case 7: {
      return this.dh;
      break;
    }
    case 8: {
      return this.cj;
      break;
    }
    case 9: {
      return this.cW;
      break;
    }
    case 10: {
      return this.cT;
      break;
    }
    case 11: {
      return this.ci;
      break;
    }
    case 12: {
      return this.cy;
      break;
    }
    case 13: {
      return this.cX;
      break;
    }
    case 14: {
      return this.dg;
      break;
    }
    case 15: {
      return this.ds;
      break;
    }
    case 16: {
      return this.cn;
      break;
    }
    case 17: {
      return this.cF;
      break;
    }
    case 18: {
      return this.cU;
      break;
    }
    case 19: {
      return this.cN;
      break;
    }
    case 20: {
      return this.dr;
      break;
    }
    case 21: {
      return this.dt;
      break;
    }
    case 22: {
      return this.di;
      break;
    }
    case 23: {
      return this.cV;
      break;
    }
    case 24: {
      return this.dj;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Recipe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jL)));
}
export { $isArrayOf_Lmealorama_Recipe as $isArrayOf_Lmealorama_Recipe };
var $d_Lmealorama_Recipe = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Recipe, "mealorama.Recipe", ({
  jL: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Recipe as $d_Lmealorama_Recipe };
//# sourceMappingURL=mealorama.-Recipe.js.map
